import React, { useState } from 'react'
import './index.css'
import { useNavigate, useLocation } from 'react-router-dom';
import { Image ,Modal} from 'react-bootstrap'
import img from '../../img/recrutement_tecna.jpeg'
import img2 from '../../img/CONCOURS.jpg'
import img3 from '../../img/INSCRIPTIONS.jpg'
import img4 from '../../img/MACARONS.jpg'
import img5 from '../../img/VOYAGE_ETUDES.jpg'
import img6 from '../../img/VACATIONS.jpg'
import img7 from '../../img/PROJETS.jpg'
import img8 from '../../img/ADMISSION.jpg'
import img9 from '../../img/PAIEMENT_UNIFORME.jpg'
import img10 from '../../img/REINSCRIPTIONS.jpg'
import admission_etranger from '../../img/ADMISSION ET_ETRAN.jpg'
import recrutenent from '../../img/RECRUTEMENTS.jpg'
import vote from'../../img/VOTE.jpg'
import erasmus from '../../img/ERASMUS.jpg'
import { useEffect } from 'react';
import axios from 'axios';
import { Paiement } from '../../components/RecepisseInscription';
import Env from '../../hooks/Env';
import RecepisseConcours from '../../components/Recepisse';
import Etranger from '../Etranger';
import CIAQ from '../../img/CIAQ.jpeg'
import Footer from '../../components/Footer/Footer';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import centre_langue from  '../../img/MONITEURS_CFVUCPL.jpg'


const Home = () => {
    useDocumentTitle('Depot de Dossier UAM');
    const API_URL = Env().API_URL ;
    // console.log(API_URL)
    const [delay, setDelay] = useState('');
    const handleClose3 = () => setDelay(false);
    const navigate = useNavigate();
    const { search } = useLocation();
    const [succes,setSucces] = useState(false);
    const [data, setData] = useState('');
    const [campagne, setCampagne] = useState('');
    useEffect(() => {
    axios.get(`${API_URL}/campagne/`)
        .then((res) => {
            setCampagne(res.data);
            
            const campagneRecrutement = res.data.find(camp => camp.nom === 'concours');
            if (campagneRecrutement) {
                // console.log('Campagne recrutement:', campagneRecrutement);
                setCampagne(campagneRecrutement);
            }
        })
        .catch((error) => {
            console.error(error);
        });
        }, [API_URL])
    const Delay = () => {
        return (
          <>
            <Modal show={delay} onHide={handleClose3}>
                    <Modal.Body className='alert alert-danger'> Cette campagne est fermée ! </Modal.Body>
                </Modal>
          </>
        )
      }
      const handleDelay = (e) => {
        if (e.target) {
          setDelay(true)
        }
      }
      
    useEffect(() => {
        const match = search.match(/email=(.*)/);
        const emailFromURL = match?.[1];
        // console.log(emailFromURL)
        if (emailFromURL){
            axios({
                url:`${API_URL}/paiement/confirmed/`,
                method: 'POST',
                data:{
                    'email':emailFromURL
                }
            })
            .then(result => {
                setData(result.data)
                if (result.data.confirmed_depot === 0) {
                    setSucces(true)
                    setData(result.data)
                    return
                }
                else if (result.data.campagne==='inscription') {
                    setSucces(true)
                    setData(result.data)
                    return
                    // navigate(`/inscription?email=${emailFromURL}`);
                }
                 else {
                    // navigate('/')
                }
            })
            .catch((error) => {
                console.error(error)
            });
      }
      }, [navigate,search])
  return (
    <div id="MainPage" className='container p-2'>
        {Delay()}
        {succes ? <RecepisseConcours  dataPerson={data}/> : null}
        {/* {succes ? <Paiement dataPerson={data} /> : null} */}
        <div id='PageBody' className='container row row-cols-4'>
            <div className={`col ${campagne && campagne.est_active ? 'ouvert' : ''}`} onClick={campagne && campagne.est_active ? ()=>{navigate('/concours')} : handleDelay}>
                <Image src={img2} />
            </div>
            <div className='col ouvert' >
                <Image src={img3} onClick={() => {navigate('/payment')}}/>
            </div>
            <div className='col ouvert'>
                <Image src={admission_etranger} onClick={() => {navigate('/admission-etranger')}}/>
                </div>
                <div className={`col ouvert mt-3`} >
                    <Image  src={img10} onClick={() => {navigate('/reinscription')}} />
                </div>
            <div className='col mt-3 ouvert' onClick={() => {navigate('/admission')}}><Image src={img8} /></div>
            <div className={`col mt-3 ${campagne && campagne.est_active ? 'ouvert' : ''}`} onClick={campagne && campagne.est_active ? ()=>{navigate('/per')} : handleDelay}>
                <Image src={recrutenent} />
            </div>
            {/* <div className='col mt-3'><Image src={img7}/></div> */}
            <div className='col mt-3 ouvert' onClick={() => {navigate('/voyage')}}><Image  src={img5} /></div>
             <div className='col' >
                    <Image  src={img7} onClick={handleDelay} />
                </div>
        </div> 
    </div>
  )
}
export default Home